<template>
  <div>
    <div>
      <div class="my-4">
        <div v-if="getReportLoadingStatus === 'INITIAL'">
          <button
            v-show="getReportLoadingStatus === 'INITIAL'"
            @click="handleClickGetReport"
            class="px-4 py-2 text-xl font-bold uppercase border-blue-600 text-blue-600 border-2 rounded-lg hover:bg-gray-100"
          >
            {{ $t("editPage.button:getReport") }}
          </button>
        </div>
        <div v-if="getReportLoadingStatus === 'LOADING'">
          <div class="text-lg text-center h-64 animate-pulse">
            {{ $t("generic.status:loading") }}
          </div>
        </div>
        <div v-else-if="getReportLoadingStatus === 'ERROR'">
          <p>
            {{ $t("editPage.errorMessage:report") }}
          </p>
          <pre>
          {{ JSON.stringify(errorMessage, null, 2) }}
        </pre
          >
        </div>
      </div>
    </div>
    <div class="mb-8">
      <PagespeedReport
        v-if="getReportLoadingStatus === 'SUCCESS'"
        :report="report"
      />
      <ReportFooter :pageUrl="reportRequestedUrl" />
    </div>
  </div>
</template>

<script>
import get from "lodash/get";

import PagespeedReport from "@/wp-pages/edit-page/components/PagespeedReport";
import ReportFooter from "@/wp-pages/edit-page/components/ReportFooter";
import { getPagespeedReportForUrl } from "@/api/moskito";
import { loadingStatuses } from "@/utils/constants";
import { getPageInfo } from "@/moskito-wordpress/utils";

export default {
  name: "PagespeedReportWrapper",
  props: {
    reportMeta: { type: Object, required: true },
  },
  components: { PagespeedReport, ReportFooter },
  data() {
    return {
      report: null,
      getReportLoadingStatus: loadingStatuses.INITIAL,
      errorMessage: "",
    };
  },
  computed: {
    reportRequestedUrl() {
      return this.report
        ? get(this.report, ["lighthouseResult", "requestedUrl"])
        : "";
    },
  },
  methods: {
    async getReport() {
      this.getReportLoadingStatus = loadingStatuses.LOADING;
      const pageInfo = getPageInfo();
      const pageUrl = pageInfo.permalink;
      const { data, error } = await getPagespeedReportForUrl(
        pageUrl,
        this.reportMeta,
      );
      if (data) {
        this.getReportLoadingStatus = loadingStatuses.SUCCESS;
        this.report = data;
      } else {
        this.getReportLoadingStatus = loadingStatuses.ERROR;
        this.errorMessage = error.message;
        console.error(error);
      }
    },
    handleClickGetReport() {
      this.getReport();
    },
  },
  mounted() {
    //this.getReport();
  },
};
</script>

<style></style>
